import {useCallback, useEffect, useState} from "react";
import {Button, DescriptionList, Modal, Thumbnail} from "@shopify/polaris";
import {useAppBridge} from "@shopify/app-bridge-react";
import Api from "../../helpers/api";

export const LineItemEngraving = ({
    modalActive,
    closeModal = () => {},
    product,
    onSave = () => {},
}) => {
    const appBridge = useAppBridge();
    const [properties, setProperties] = useState({});

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        window.addEventListener('message', childIframeMessageListener);

        return () => {
            window.removeEventListener('message', childIframeMessageListener);
        };
    }, []);

    const childIframeMessageListener = async (eventMessage) => {
        if (eventMessage.data.engraving) {
            setLoading(true);
            // These come in as {"properties[key]": "value"}
            let data = {};
            let previewData = null;
            for (let key in eventMessage.data.engraving) {
                if (key.startsWith('properties')) {
                    let value = eventMessage.data.engraving[key];
                    key = key.replace(/properties\[(.+?)\]/, '$1');

                    if (key == 'Preview') {
                        previewData = value;
                    } else {
                        data[key] = value;
                    }
                }
            }
            setProperties(data);

            if (previewData) {
                const response = await Api.uploadBase64FileForCart(previewData);
                data['Preview'] = response.data;
            }

            setProperties(data);
            setLoading(false);
        }
    };

    const onClose = useCallback(async () => {
        setLoading(true);
        if (properties['Preview'] && properties['Preview'].path) {
            await Api.deleteFileForCart(properties['Preview'].path);
        }
        setProperties({});
        closeModal();
    }, [properties]);

    return (<Modal
        title={"Engraving"}
        open={modalActive}
        size={"large"}
        onClose={onClose}
        primaryAction={{
            content: "Confirm",
            loading: loading,
            disabled: Object.entries(properties).length == 0,
            onAction() {
                onSave(properties);
                setProperties({});
            }
        }}
        secondaryActions={[
            {
                content: 'Cancel',
                disabled: loading,
                onAction: onClose,
            },
        ]}
    >
        <Modal.Section>
            {!!product?.handle && Object.entries(properties).length == 0 && (
                <iframe
                    src={`https://${window.shopifyDomain}/products/${product.handle}?view=pos`}
                    style={{ width: '100%', height: '70vh' }}
                />
            )}
        </Modal.Section>
        <Modal.Section>
            <DescriptionList
                items={Object.entries(properties)
                    .map(([key, value]) => {
                        if (key == 'Preview') {
                            return { term: key, description: <Thumbnail source={value.url} alt={''} size={'medium'} />};
                        }

                        return { term: key, description: value };
                    })}
            />
        </Modal.Section>
    </Modal>);
}


export const LineItemEngravingDescription = ({
     modalActive,
     closeModal = () => {},
     product,
 }) => {
    return (<Modal
        title={"Engraving"}
        open={modalActive}
        size={"large"}
        onClose={closeModal}
        secondaryActions={[
            {
                content: 'Close',
                onAction: closeModal,
            },
        ]}
    >
        <Modal.Section>
            <DescriptionList
                items={(product?.engravingProperties ?? [])
                    .map(({key, value}) => {
                        if (key == 'Preview') {
                            return { term: key, description: <Thumbnail source={value.url} alt={''} size={'medium'} />};
                        }

                        return { term: key, description: value };
                    })}
            />
        </Modal.Section>
    </Modal>);
}
